// Per-platform behaviour shared between the individual mapping pages and the
// combined view. `skuLabel` names the identifier stored in platform_sku;
// `variationLabel` (when set) names the secondary identifier stored in variation_sku.
export const PLATFORM_CONFIG = {
  shopify: {
    label: 'Shopify', hasStores: false, storeApi: null,
    skuLabel: 'Shopify SKU', skuPlaceholder: 'e.g. BAPPBKWP',
    variationLabel: null, hasPush: true, pushPath: 'push-shopify-quantity', perStorePush: false,
  },
  ebay: {
    label: 'eBay', hasStores: true, storeApi: '/ebay/stores', storeNoun: 'store',
    skuLabel: 'eBay Item ID', skuPlaceholder: 'e.g. 123456789012',
    variationLabel: 'Variation SKU (optional)', variationPlaceholder: 'e.g. BAPPBKWP-5',
    variationHint: 'Only needed if this Item ID is a multi-variation listing (several colours under one listing)',
    hasPush: true, pushPath: 'push-ebay-quantity', perStorePush: true,
  },
  amazon: {
    label: 'Amazon', hasStores: true, storeApi: '/amazon/stores', storeNoun: 'store',
    skuLabel: 'Seller SKU', skuPlaceholder: 'e.g. GCTB34R-P',
    variationLabel: 'ASIN / Barcode (optional)', variationPlaceholder: 'e.g. B07MN5B13N',
    variationHint: 'Reference identifier — shown under the SKU, not used for order matching',
    hasPush: true, pushPath: 'push-amazon-quantity', perStorePush: true,
  },
};
